// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WxBm","label":"styles_label__2DbEk"};